import {Exclude, Expose} from "class-transformer";

@Exclude()
export class MessageApiModel {
  @Expose() public message: string;
}
